import EmailStep from './EmailStep'
import OTPStep from './OTPStep'

export default {
    EmailStep,
    OTPStep,
}
